var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54464 0.864258L7.14286 1.5625H1.78571C0.797991 1.5625 0 2.26074 0 3.125C0 3.98926 0.797991 4.6875 1.78571 4.6875H23.2143C24.202 4.6875 25 3.98926 25 3.125C25 2.26074 24.202 1.5625 23.2143 1.5625H17.8571L17.4554 0.864258C17.154 0.332031 16.5346 0 15.8594 0H9.14062C8.4654 0 7.84598 0.332031 7.54464 0.864258ZM23.2143 6.25H1.78571L2.96875 22.8027C3.05804 24.0381 4.22991 25 5.64174 25H19.3583C20.7701 25 21.942 24.0381 22.0312 22.8027L23.2143 6.25Z",
    fill: "url(#paint0_linear_4573_677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4573_677",
    x1: 0,
    y1: 12.5,
    x2: 25,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443E65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default __webpack_public_path__ + "static/media/trashcan-icon.6e2dd91a7a2b4271408fd9792ffa637e.svg";
export { ForwardRef as ReactComponent };